import { render } from "./DeviceSpecificationView.vue?vue&type=template&id=4abaf66c"
import script from "./DeviceSpecificationView.vue?vue&type=script&lang=js"
export * from "./DeviceSpecificationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__